var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBellIcon = function SvgBellIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bell-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#3AACC8",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M5.989 12.25a1.167 1.167 0 0 0 2.02 0M1.903 8.94a.583.583 0 0 0 .43.977h9.334a.584.584 0 0 0 .432-.976c-.776-.8-1.598-1.65-1.598-4.274a3.5 3.5 0 0 0-7 0c0 2.624-.823 3.474-1.598 4.273Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bell-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h14v14H0z"
  })))));
};
export { SvgBellIcon as ReactComponent };
export default __webpack_public_path__ + "9fbb6c145e044daf1d2695f9f9e8f123.svg";